export enum ValidationLevel {
  ERROR = 'ERROR',
  WARNING = 'WARNING',
}

export interface ValidationError {
  level: ValidationLevel;
  message: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
  warnings: ValidationError[];
}

export interface SectionValidation {
  sectionId: string;
  result: ValidationResult;
}
